import { Scanner } from "../../components/Scanner/Scanner";

export function Entrata() {
    return (
        <div className="App">
          <Scanner/>
        </div>
    );
}